/**
 * Componente radice della shell ERP.
 *
 * Definisce l'albero delle route React Router v6:
 *   /login          → LoginPage (pubblica)
 *   /               → redirect a prima route del primo modulo registrato
 *   /*              → AuthGuard → Layout → route dei moduli installati
 *
 * Le route dei moduli vengono generate dinamicamente da registeredModules,
 * consentendo l'aggiunta di nuovi moduli senza modificare questo file.
 */

import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AuthGuard from './AuthGuard';
import Layout from './Layout';
import LoginPage from './LoginPage';
import ProfiloUtente from './ProfiloUtente';
import SetupWizard from './SetupWizard';
import NotifichePage from '../pages/NotifichePage';
import { registeredModules } from '../registry/modules';

/** Prima route navigabile del primo modulo registrato. Usata per il redirect /. */
const _primaRoute =
  registeredModules[0]?.routes.find((r) => !r.hidden)?.path ?? '/login';

const App: React.FC = () => (
  <Routes>
    {/* Route pubbliche */}
    <Route path="/login" element={<LoginPage />} />
    <Route path="/setup" element={<SetupWizard />} />

    {/* Route protette — AuthGuard → Layout → Outlet */}
    <Route element={<AuthGuard />}>
      <Route element={<Layout />}>
        {/* Redirect radice alla prima pagina del primo modulo */}
        <Route index element={<Navigate to={_primaRoute} replace />} />

        {/* Profilo utente corrente */}
        <Route path="/profilo" element={<ProfiloUtente />} />

        {/* Notifiche utente corrente */}
        <Route path="/notifiche" element={<NotifichePage />} />

        {/* Route generate dal registry dei moduli */}
        {registeredModules.flatMap((mod) =>
          mod.routes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={<route.component />}
            />
          ))
        )}
      </Route>
    </Route>
  </Routes>
);

export default App;
